import { ISettlementInfoContractForm } from 'services/music-product-digital/types/form';
import { ISettlementInfoContractMutation } from 'services/music-product-digital/types/mutation';
import { IInfinitePageParams, IInfinitePageResponse } from 'services/types';

export interface IChannelSearch extends IInfinitePageParams {
  name?: string;
  id?: string;
  link?: string;
  hasContracts?: boolean;
}

export interface IChannelResponse {
  id: string;
  externalChannelId: string;
  name: string;
  link: string;
  imageLink: string;
  subscribersCount: number;
  totalViews: number;
  totalVideoCount: number;
  lastSyncDate?: string;
  settlementInfo: IChannelSettlementInfoForm | null;
  version: number;
}

export interface IChannelSettlementInfoForm {
  perVideoSettlement: boolean;
  contracts: ISettlementInfoContractForm[];
}

export interface IChannelMutationForm {
  id: string;
  externalChannelId?: string;
  name: string;
  link: string;
  imageLink: string;
  settlementInfo: IChannelSettlementInfoForm | null;
  subscribersCount: number;
  totalViews: number;
  lastSyncDate?: string;
  totalVideoCount: number;
  version: number;
}

export interface IChannelVideoResponse {
  id: string;
  videoTitle: string;
  externalVideoId: string;
  videoImageLink: string;
  dateOfPublication: string | null;
  views: number;
  likesCount: number;
  dislikesCount: number;
  lastSyncDate?: string;
  isShorts: boolean;
  videoType: { id: VIDEO_TYPE };
}

export interface IChannelVideoSearch extends IInfinitePageParams {
  channelId: string;
  videoTitle?: string;
  externalVideoId?: string;
  assetId?: string;
  videoType?: VIDEO_TYPE;
}

export interface IChannelVideoForm extends IChannelVideoResponse {
  videoContracts: ISettlementInfoContractForm[];
}

export interface IContractResponse {
  id: string;
  startDate: string;
  endDate: string;
  title: string;
  status: string;
}

export interface IChannelPageResponse
  extends IInfinitePageResponse<IChannelResponse> {}

export interface ICreateChannelById {
  channelId: string;
}

export interface ICreateChannelByLink {
  link: string;
}

export interface IUpdateChannel {
  channelId: string;
}

export interface IChannelForm {
  channelId: string;
}

export interface IChannelVideoRemove {
  channelVideoId: string;
}

export interface ICreateChannelContract {
  channelId: string;
  settlementInfo: {
    contracts?: ISettlementInfoContractMutation[];
    perVideoSettlement: boolean;
  } | null;

  version: number;
}
export interface IUpdateVideoContract {
  channelId: string;
  videoId: string;
  videoContracts: ISettlementInfoContractMutation[];
}

export interface IChannelVideoContractsTime {
  id: string;
  videoContracts: ISettlementInfoContractForm[];
}

export interface IChannelSyncAll {
  updateChannel: boolean;
  updateVideos: boolean;
  addNewVideos: boolean;
  updateAll: boolean;
}

export interface IChannelsSync extends Omit<IChannelSyncAll, 'updateAll'> {}
export interface IChannelSync extends IChannelsSync {
  channelId: string;
}

export interface IAddVideoById {
  videoId: string;
}

export interface IChannelAssetIdSearch extends IInfinitePageParams {
  channelId?: string;
  videoId?: string;
}

export interface IChannelAssetIdResponse {
  id: string;
  channelId: string;
  videoId: string;
  assetId: string;
}

export interface ICreateChannelAssetId {
  channelId: string;
  assetId: string;
  videoId: string | null;
}

export interface IAutoAssignChannelAssetIdVideo {
  videoId: string;
}

export interface IBulkAssignVideoContract {
  contractId: string;
  divisionPercentage: number;
  startDate: string;
}

export interface IBulkAssignVideoContracts {
  channelId: string;
  videoIds: string[];
  videoContracts: IBulkAssignVideoContract[];
}

export enum VIDEO_TYPE {
  video = 1,
  shorts = 2,
}
